module.exports = __webpack_public_path__ + "img/measurement_info_back_elbow_left.356959eb.jpg";